import React from 'react';
import { Route, RouteComponentProps } from 'react-router-dom';

import { QuestionsAdd } from './questions-add';

function questionsAddRoute(routeProps: RouteComponentProps) {
  return (
    <Route
      path={`${routeProps.match.path}/add`}
      render={() => (
        <>
          <QuestionsAdd />
        </>
      )}
    />
  );
}

export { questionsAddRoute };
